<template> 
    <div :class="['content-container', 'ipad', {'desktop': !this.isIpad}]">

        <NavBar></NavBar> 

        <!-- Content -->
        <div class="container">
            <div class="grid-container">
                <a href="#" class="grid-item product">
                    <img src="img/products/xarelto.jpg" alt="Xarelto" class="product-img">
                    <h2 class="title">Xarelto (rivaroxaban)</h2>
                    <h3 class="subtitle">(Factor Xa inhibitor)</h3>
                </a>
                <a href="#" class="grid-item product">
                    <img src="img/products/finerenone.jpg" alt="Finerenone" class="product-img">
                    <h2 class="title">Finerenone</h2>
                    <h3 class="subtitle">(nsa MR antagonist)</h3>
                </a>
                <a href="#" class="grid-item product">
                    <img src="img/products/vericiguat.jpg" alt="Vericiguat" class="product-img">
                    <h2 class="title">Vericiguat</h2>
                    <h3 class="subtitle">(sGC stimulator)</h3>
                </a>
            </div>
        </div>


        <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/product-bg.jpg" class="bottom-center">
        </div>
    </div>
</template>


<script>

    import NavBar from './components/NavBar.vue'; 

    export default {
        name: 'TrialsOne',
        components: {
            NavBar 
        }
    }


</script>